export interface MaterialProductContract {
  codename: string;
  id: number;
  name: string;
  title: string;
  type: string;
  color: string;
  short_title: string;
}